import { createContext, useContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const MAIN_URL = process.env.REACT_APP_URL

    const [token, setToken] = useState(localStorage.getItem("token"));
    const [user, setUser] = useState("");
  
    const storeTokenInLS = (serverToken) => {
      return localStorage.setItem("token", serverToken);
    };
  
    //Logout User
    const LogoutUser = () => {
      setToken("");
      return localStorage.removeItem("token");
    };
  
  // function to check the user Authentication or not
  const userAuthentication = async () => {
      try {
        const response = await fetch(`${MAIN_URL}/api/auth/user`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.ok) {
          const data = await response.json();
          console.log("User Data: ", data.userData);
          console.log("user id",data._id )
          setUser(data.userData);
        }
      } catch (error) {
        console.log("Error fetching user data: ", error);
      }
    };
    useEffect(() => {
      userAuthentication();
      // eslint-disable-next-line
    }, []);
  
    return (
      <AuthContext.Provider value={{ storeTokenInLS, LogoutUser, user }}>
        {children}
      </AuthContext.Provider>
    );
  };

  export const useAuth = () => {
    const authContextValue = useContext(AuthContext);
    if (!authContextValue) {
      throw new Error("useAuth used outside of the Provider");
    }
    return authContextValue;
  };